// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"15e59942","453":"fa7e0ad7","455":"c93de497","977":"441225e3"}[chunkId] + ".chunk.js";
};